module.exports = __webpack_public_path__ + "static/media/6.6300111d.jpg";